<script lang="ts">
	//UI
	import { DefaultSwitch } from "@hitit/new_ui";
	//Image
	import closeBtn from "@hitit/hub/src/assets/Icons/closeBtn.png";
	//Utils
	import { t } from "@hitit/hub/src/stores";
	//Types
	import type {
		OptionCategoryData,
		OptionCollectionItemDTO,
	} from "@hitit/api/src/types";
	import { formatNumber } from "@hitit/utils";
	//Props
	export let optionCategory: OptionCategoryData[];
	export let modalClose: () => void;
	export let editmode: boolean;
	//Constants
	//Variables
	let available = false;
	let selectOption: OptionCollectionItemDTO[];
	let selectedOtionCategoryName = "";
	let selectedOtionCategoryId = "";
	//Functions

	function selectedCategory(index: number) {
		selectOption = optionCategory[index].optionCollectionItemDTO;
		selectedOtionCategoryId = optionCategory[index].id || "";
		selectedOtionCategoryName = optionCategory[index].translationDTOs[0].name;
	}

	function selfOrderFunctionChangeHandler(e: Event) {
		const target = e.target as HTMLInputElement;
		available = target.checked ? true : false;
	}
	//Do
	selectedCategory(0);
</script>

<div class="modal-background" t-id="OptionModal">
	<div class="modal-container">
		<img class="modal-close" src={closeBtn} alt="close" on:click={modalClose} />
		<div class="modal-wrapper">
			<span class="title">{$t("mbr.self_order.exposure_options")}</span>
			<div class="category-box">
				{#each optionCategory as category, index}
					<span
						on:click={() => selectedCategory(index)}
						class:selected={optionCategory[index].id ===
							selectedOtionCategoryId}
						>{category.translationDTOs[0].name} ({category
							.optionCollectionItemDTO.length})</span
					>
				{/each}
			</div>
			<div class="top-wrapper">
				{#if editmode}
					<DefaultSwitch
						checked={available}
						on:change={selfOrderFunctionChangeHandler}
					/>
					<span class="menu-name">{selectedOtionCategoryName}</span>
					<span class="selected-number">총 20개 선택</span>
				{:else}
					<span class="menu-name"
						>{selectedOtionCategoryName} ({selectOption.length})</span
					>
				{/if}
			</div>
			<div class="item-wrapper">
				{#each selectOption as option}
					<div class="option">
						<span class="name">{option.translationDTOs[0].name}</span>
						<span class="price">{formatNumber(option.price)}원</span>
					</div>
				{/each}
				{#each selectOption as option}
					<div class="option">
						<span class="name">{option.translationDTOs[0].name}</span>
						<span class="price">{formatNumber(option.price)}원</span>
					</div>
				{/each}
				{#each selectOption as option}
					<div class="option">
						<span class="name">{option.translationDTOs[0].name}</span>
						<span class="price">{formatNumber(option.price)}원</span>
					</div>
				{/each}
			</div>
		</div>
		{#if editmode}
			<button class="done">완료</button>
		{/if}
	</div>
</div>

<style lang="scss">
	@import "../../../../variables.scss";
	.modal-background {
		position: fixed;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		width: 100vw;
		height: 100vh;
		background: rgba(70, 71, 75, 0.7);
		z-index: 1000;
	}

	.modal-container {
		position: absolute;
		display: flex;
		flex-direction: column;
		/* min-width: 740px; */
		/* max-width: 1050px; */
		width: 86%;
		/* height: 700px; */
		/* min-height: 300px; */
		top: 60px;
		bottom: 0;
		left: 0;
		right: 0;
		margin: auto;
		margin-bottom: 10px;
		background-color: white;
		border-radius: 5px;
		padding: 10px;

		.modal-wrapper {
			/* max-width: 950px; */
			overflow: hidden;
			margin-bottom: 25px;
		}

		.title {
			@include appleAdjustTextForSize(20);
			/* font-size: 34px; */
			font-weight: 500;
		}

		.category-box {
			display: flex;
			gap: 20px;
			margin-top: 20px;
			padding-bottom: 2px;

			&::-webkit-scrollbar {
				height: 1px;
			}
			&::-webkit-scrollbar-track {
				background-color: transparent;
			}
			&::-webkit-scrollbar-thumb {
				background-color: #bcbfc3;
			}

			span {
				min-width: fit-content;
				@include appleAdjustTextForSize(16);
				font-weight: 400;
				color: #6d6f76;
				cursor: pointer;

				&.selected {
					color: #3c68d6;
				}
			}
		}

		.top-wrapper {
			display: flex;
			align-items: center;
			gap: 10px;
			margin-top: 20px;

			.menu-name {
				@include appleAdjustTextForSize(20);
				/* font-size: 34px; */
				font-weight: 550;
				color: #46474b;
			}

			.selected-number {
				font-size: 20px;
				margin-left: auto;
				color: #6d6f76;
			}
		}

		.item-wrapper {
			display: flex;
			flex-wrap: wrap;
			/* min-height: 500px; */
			height: 76%;
			gap: 10px;
			margin-top: 10px;
			overflow-y: auto;

			.option {
				display: flex;
				flex-direction: column;
				gap: 35px;
				width: calc(100% - 25px);
				/* height: 97px; */
				background-color: #f0f0f4;
				border-radius: 5px;
				padding: 10px;

				.name {
					@include appleAdjustTextForSize(16);
					/* font-size: 20px; */
					font-weight: 500;
					color: #46474b;
				}
				.price {
					@include appleAdjustTextForSize(16);
					/* font-size: 20px; */
					color: #46474b;
				}
			}

			&::-webkit-scrollbar {
				width: 2px;
			}
			&::-webkit-scrollbar-track {
				background-color: transparent;
			}
			&::-webkit-scrollbar-thumb {
				background-color: #bcbfc3;
			}
		}

		.modal-close {
			position: absolute;
			top: -43px;
			right: 0px;
			width: 30px;
			height: 30px;
			cursor: pointer;
		}
	}

	.done {
		display: flex;
		justify-content: center;
		align-items: center;
		min-height: 40px;
		border: 0;
		color: white;
		font-weight: 400;
		font-size: 20px;
		background-color: #6591fa;
		border-radius: 5px;
		margin-top: auto;
	}
	@include DesktopSize {
		.modal-container {
			width: 50%;
			height: 700px;
			min-height: 300px;
			top: 0;
			margin: auto;
			padding: 30px;

			.title {
				font-size: 34px;
			}

			.category-box {
				gap: 30px;
				margin-top: 30px;

				span {
					@include appleAdjustTextForSize(16, false);
				}
			}

			.top-wrapper {
				.menu-name {
					font-size: 34px;
				}
			}

			.item-wrapper {
				height: 73%;
				gap: 20px;
				margin-top: 20px;

				.option {
					width: 183px;
					padding: 20px;

					.name {
						@include appleAdjustTextForSize(16, false);
					}
					.price {
						@include appleAdjustTextForSize(16, false);
					}
				}
			}

			.modal-close {
				top: 0;
				right: -60px;
				width: 40px;
				height: 40px;
			}
		}

		.done {
			font-size: 20px;
		}
	}
</style>
